<mat-radio-button
  class="radio-button-list"
  [checked]="subscriptionToUpgrade === voiceProduct.id"
  [disabled]="!isUpgradeAllowed || subscriberExceedsUpperAgeLimit || subscriberIsBelowLowerAgeLimit"
  [matTooltip]="tooltipText"
  [value]="voiceProduct.id"
>
  <div class="mobile-phone-existing-offering-upgrade">
    <span>
      {{ voiceProduct.subscription.msisdn }} -
      {{
        voiceProduct.offering?.id
          ? voiceProduct.offering.name
          : voiceProduct.assignedSubscription?.mobilePlan?.productDetails?.name || voiceProduct.subscription.productName
      }}
      {{ vasOfferingProductName }}
    </span>
    @if (voiceProduct.offering?.id) {
      <span>(handlekurv)</span>
    }
    @if (voiceProduct.isLoadingSubscriptionOfferings) {
      <app-spinner size="medium" />
    } @else {
      @if (displayTerminationFee) {
        <app-ice-badge class="breakage-fee-message" type="error">
          Bruddgebyr {{ changeInfoForUpgrade.changeInfo.remainingBreakageFee | priceFormat: priceType.OneTime }}
          @if (SubscriptionHelperService.getFutureBindingExpirationDate(voiceProduct); as expirationDate) {
            <span>- avtaletid til {{ expirationDate | date: 'dd.MM.yyyy' }}</span>
          }
        </app-ice-badge>
      }
    }
  </div>
</mat-radio-button>
